import { useCallback, useRef, useState } from "react";
import { CloseIcon } from "../../assets/icons";
import classNames from "classnames";

import styles from "./popup.module.css";

export const Popup = ({ children, active, setActive, className, ...props }) => {
    return (
        <div className={classNames(styles.popup_container, { [styles.active]: active })} onClick={(e) => {
            e.stopPropagation();
            setActive(false);
        }}>
            <div className={classNames(styles.popup_box, className)} onClick={e => e.stopPropagation()} {...props}>
                <CloseIcon className={styles.popup_close} onClick={() => setActive(false)} />
                <div className={styles.popup_inner}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export const usePopup = () => {
    const [active, setActive] = useState(false);
    const activeRef = useRef(active);

    activeRef.current = active;

    const show = useCallback(() => {
        setActive(true);
    }, []);

    const hide = useCallback(() => {
        setActive(false);
    }, []);

    const renderPopup = useCallback(({ children, ...props }) => {
        return <Popup
            active={activeRef.current}
            setActive={setActive}
            {...props}
        >
            {children}
        </Popup>;
    }, []);

    return [renderPopup, show, hide, active];
};
